import { render, staticRenderFns } from "./parts_orders_section.vue?vue&type=template&id=3c0bccd6&"
import script from "./parts_orders_section.vue?vue&type=script&lang=js&"
export * from "./parts_orders_section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports